var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 240,
    viewBox: "0 0 241 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3280"
  }, /*#__PURE__*/React.createElement("g", {
    id: 31
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M201.552 163.091C205.094 163.091 207.966 160.219 207.966 156.677C207.966 153.135 205.094 150.264 201.552 150.264C198.01 150.264 195.139 153.135 195.139 156.677C195.139 160.219 198.01 163.091 201.552 163.091Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M189.235 180.985C191.654 180.985 193.615 179.024 193.615 176.605C193.615 174.186 191.654 172.225 189.235 172.225C186.816 172.225 184.855 174.186 184.855 176.605C184.855 179.024 186.816 180.985 189.235 180.985Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.3136 73.9267C49.7326 73.9267 51.6936 71.9657 51.6936 69.5467C51.6936 67.1277 49.7326 65.1667 47.3136 65.1667C44.8946 65.1667 42.9336 67.1277 42.9336 69.5467C42.9336 71.9657 44.8946 73.9267 47.3136 73.9267Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.5644 158.398C25.0569 158.398 28.6987 154.756 28.6987 150.264C28.6987 145.771 25.0569 142.129 20.5644 142.129C16.072 142.129 12.4302 145.771 12.4302 150.264C12.4302 154.756 16.072 158.398 20.5644 158.398Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M119.349 199.226C163.148 199.226 198.658 163.716 198.658 119.76C198.658 75.8038 163.148 40.2947 119.349 40.2947C75.5487 40.2947 40.0396 75.8038 40.0396 119.76C40.0396 163.716 75.5487 199.226 119.349 199.226Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M165.407 52.2388C167.766 52.2388 169.762 54.0445 169.762 56.5724V184.416C169.762 186.763 167.947 188.749 165.407 188.749H70.8644C68.5054 188.749 66.5093 186.944 66.5093 184.416V56.5724C66.5093 54.225 68.3239 52.2388 70.8644 52.2388H165.407Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M169.762 65.6007V184.235C169.762 186.582 167.948 188.568 165.407 188.568H79.0306L71.4092 180.985L157.241 63.4339L164.681 60.7253L169.762 65.6007Z",
    fill: "#BCC4CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M165.044 62.1699C165.044 61.4476 164.5 60.7253 163.593 60.7253H72.8609C72.135 60.7253 71.4092 61.2671 71.4092 62.1699V179.54C71.4092 180.262 71.9536 180.985 72.8609 180.985H163.411C164.137 180.985 164.863 180.443 164.863 179.54L165.044 62.1699Z",
    fill: "#D9DFEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M165.044 62.1699C165.044 61.4476 164.5 60.7253 163.592 60.7253H72.8608C72.1349 60.7253 71.4091 61.2671 71.4091 62.1699C72.4978 108.937 72.8608 161.844 67.7798 175.567L154.701 174.304C159.963 150.468 163.955 107.673 165.044 62.1699Z",
    fill: "#EFF3FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    filter: "url(#filter0_d_2089_13637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.863 60.9062C164.863 60.9062 164.681 67.9485 162.504 112.91C162.504 113.271 162.504 113.452 162.504 113.813C159.782 157.872 120.586 167.081 115.868 167.623C113.69 167.803 109.516 168.164 102.076 168.164C92.8218 168.526 78.6677 168.706 56.5292 168.887C55.8033 168.887 55.2589 168.164 55.6219 167.442C70.8648 136.926 71.0462 61.0868 71.0462 61.0868L164.863 60.9062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M162.322 113.632C159.782 157.691 120.404 166.9 115.686 167.442C113.509 167.623 109.335 167.984 101.895 167.984C121.493 158.955 132.018 142.704 131.836 130.064C141.273 130.786 157.604 130.064 162.322 113.632Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M140.184 52.5998C140.184 52.4192 140.184 52.4192 140.184 52.5998L139.277 51.6969C139.277 51.6969 138.732 51.8775 138.551 52.2386H124.397C124.397 51.8775 124.397 51.6969 124.397 51.3358C124.397 48.4467 121.856 45.9187 118.953 45.9187C116.049 45.9187 113.509 48.4467 113.509 51.3358C113.509 51.6969 113.509 51.8775 113.69 52.0581H98.9917C98.2659 52.0581 97.54 52.5998 97.54 53.6832V58.378C97.54 61.9894 100.081 64.1562 103.528 64.1562H133.651C137.28 64.1562 140.365 61.9894 140.365 58.378V53.5026C140.547 53.1415 140.365 52.7803 140.184 52.5998Z",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M139.639 52.5999V57.2947C139.639 57.6559 139.639 57.8364 139.639 58.1976C139.095 61.2673 136.554 63.7952 133.288 63.7952H102.984C99.7172 63.7952 97.1767 61.2673 96.6323 58.1976C96.6323 57.8364 96.6323 57.6559 96.6323 57.2947V52.5999C96.6323 51.8777 97.1767 50.9748 98.084 50.9748H112.964C112.964 50.6137 112.964 50.4331 112.964 50.2525C112.964 47.3634 115.505 44.8354 118.408 44.8354C121.311 44.8354 123.852 47.3634 123.852 50.2525C123.852 50.6137 123.852 50.7942 123.852 50.9748H138.732C139.095 51.1554 139.639 51.6971 139.639 52.5999Z",
    fill: "url(#paint0_linear_2089_13637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M118.045 52.7806C119.497 52.7806 120.586 51.6971 120.586 50.2526C120.586 48.808 119.497 47.7246 118.045 47.7246C116.594 47.7246 115.505 48.808 115.505 50.2526C115.505 51.6971 116.775 52.7806 118.045 52.7806Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M139.458 58.1978C138.913 61.2674 136.373 63.7954 133.106 63.7954H102.984C99.7172 63.7954 97.1767 61.2674 96.6323 58.1978H139.458Z",
    fill: "#9AA1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M93.7295 113.091C96.6329 113.091 98.8104 110.743 98.8104 108.035C98.8104 105.146 96.4514 102.979 93.7295 102.979C90.826 102.979 88.6485 105.326 88.6485 108.035C88.467 110.743 90.826 113.091 93.7295 113.091Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M134.014 112.91C136.917 112.91 139.095 110.563 139.095 107.854C139.095 104.965 136.736 102.798 134.014 102.798C131.292 102.798 128.933 105.146 128.933 107.854C128.933 110.563 131.111 112.91 134.014 112.91Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M118.771 118.508H108.972V120.855H118.771V118.508Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M216.58 61.4478C220.572 80.227 220.027 100.09 214.583 118.508C213.313 122.3 212.043 126.453 209.321 129.342C205.51 133.856 198.615 135.842 192.989 134.398C187.183 132.953 182.464 127.897 181.376 121.758C180.468 117.966 181.739 113.452 185.005 111.104C188.453 108.938 193.352 109.479 196.256 112.188C199.522 114.896 200.792 119.049 200.611 123.022C200.429 126.994 198.978 130.967 196.982 134.398C190.993 145.593 180.105 154.441 167.584 158.414C158.33 161.303 148.349 161.303 139.095 158.775",
    stroke: "#C9D4E2",
    strokeWidth: 3.12856,
    strokeMiterlimit: 10,
    strokeDasharray: "6.26 6.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M224.201 56.0309C223.656 58.0172 221.479 58.7395 219.301 57.4755C216.942 56.3921 215.309 55.4892 215.672 53.6835C216.216 51.8778 218.394 51.6973 220.934 51.5167C224.019 51.1555 224.564 54.0447 224.201 56.0309Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M206.599 57.8363C207.506 59.4614 210.047 60.5448 211.862 58.9197C213.858 57.114 215.491 55.85 214.583 54.0443C213.676 52.4192 212.224 52.9609 209.14 53.322C206.599 53.8638 205.51 56.0306 206.599 57.8363Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M214.584 51.1553C215.854 50.9748 217.124 51.697 217.487 52.7805C217.669 53.1416 217.85 53.6833 217.85 54.0444C218.213 56.5724 217.306 58.7393 215.854 58.9198C214.221 59.281 212.588 57.4753 212.406 55.1279C212.406 54.4056 212.406 54.0444 212.406 53.5027C212.588 52.2388 213.314 51.3359 214.584 51.1553C214.765 51.1553 214.584 51.1553 214.584 51.1553Z",
    fill: "#989FB0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2089_13637",
    x: 21.0922,
    y: 43.6992,
    width: 178.185,
    height: 176.809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.2071
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2071
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2089_13637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2089_13637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2089_13637",
    x1: 96.6842,
    y1: 54.3177,
    x2: 139.68,
    y2: 54.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageEmpty);
export default __webpack_public_path__ + "static/media/page-empty.bf7726e693734319a40128cc919a2c4b.svg";
export { ForwardRef as ReactComponent };